import { useEffect } from "react";
import { _AdquisitionItem } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";

interface Props{
    idProject:number;
}

export const AdquisitionProjectLines = ({idProject}:Props) => {

    const _items = useDataBean(_AdquisitionItem);
    const {lista,setLista,bean,setBean} = _items;
    useEffect(()=>{
        if(idProject)
        {
            let filter = {
                IDProject:idProject
            }
            _items.instance.getAdquisitionItemByProps(1,10000,filter).then(
                (resp:any)=>{
                    setLista(resp.List);
                }
            )
        }
    },[idProject])
 
      const head = [
            { title: 'ID', property: "IDAdquisitionItem", mask: MASK_NUMBER, visible: true },            
            { title: 'Año PAA', property: 'Year',mask:MASK_NUMBER,visible:true },            
            { title: 'Necesidad', property: 'Description' },                                                                                       
            { title: 'Rubro', property: 'IDLnBudgetIDNameList' },            
            { title: 'Valor Estimado', property: 'TotalValue', mask: MASK_MONEY },                                    
            { title: 'PF', property: 'PFTotal', mask: MASK_MONEY, visible: true },
            { title: 'CDP', property: 'CDPTotal', mask: MASK_MONEY, visible: true },            
            { title: 'Saldo CDP', property: 'LeftValue', mask: MASK_MONEY, visible: true },                                    
            { title: "Estado", property: "PreparationStateName" },
        ]

    return (
        <div className="row">
            <div className="col">
                <BasicTable head={head} body={lista} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}